<!-- <p-tabMenu [model]="tabMenuItems()">
  <ng-template pTemplate="item" let-item>
    <ng-container *appRights="item.rights">
      <a [routerLink]="item.routerLink" pRipple class="flex align-items-center gap-2 p-menuitem-link">
        <span class="material-symbols-rounded">
          {{ item.icon }}
        </span>
        <span class="font-bold">
          {{ item.label }}
        </span>
      </a>
    </ng-container>
  </ng-template>
</p-tabMenu>
<div class="p-4">
  <router-outlet></router-outlet>
</div> -->

<div class="flex gap-4 p-4 surface-100">
  @for (item of tabMenuItems(); track $index) {
    <ng-container *appRights="item.rights">
      <div
        class="flex gap-3 align-items-center cursor-pointer border-round-xs border-1 border-200 p-3 surface-0"
        routerLinkActive="active-card"
        [routerLink]="item['routerLink']"
      >
        <span class="material-symbols-rounded">
          {{ item["icon"] }}
        </span>
        <div>
          <p class="[ label ] [ m-0 mb-1 font-medium ]">{{ item["label"] }}</p>
          @if (item["description"]) {
            <p class="text-xs text-gray-600 m-0 mt-1">
              {{ item["description"] }}
            </p>
          }
        </div>
      </div>
    </ng-container>
  }
</div>
<div class="surface-0">
  <router-outlet></router-outlet>
</div>